<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增表单项
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="icon"
          slot-scope="text, record"
        >
          <img
            width="100"
            height="100"
            :src="record.icon"
            alt="图标"
          >
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => onDetails(record)"
          >查看</a>
          <a-divider
            v-if="record.data.can_edit_flag===1"
            type="vertical"
          />
          <a
            v-if="record.data.can_edit_flag===1"
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status==='1'?'禁用':'启用'"
            :alert-title="record.status==='1'?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { columns } from './data/index';
export default {
  data() {
    return {
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      activityVisible: false,
      title: '',
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/TypeAndConfig/getList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            label: item.label,
            sort: item.sort,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    editAndAdd(record){
      if(record){
        this.$router.push({path: '/type/add', query: {id: record.id, disabled: 'false'}});
      }else{
        this.$router.push({path: '/type/add' });
      }

    },
    onDetails(record){
      this.$router.push({path: '/type/add', query: {id: record.id, disabled: 'true'}});
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/TypeAndConfig/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/TypeAndConfig/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
